import { value } from "~/components/helpers";
import { type AppContext } from "~/lib/context";
import {
  formatCompensationReviewCampaign,
  formatKnockTenant,
  formatKnockUser,
  selectUserForFormat,
} from "~/lib/external/knock/format";
import { track } from "~/lib/external/segment/server/client";
import { chain } from "~/lib/lodash";
import { type EventPayload } from "~/workers/handleEvent";

export const notifyReviewersOfCampaignClosed = async (
  ctx: AppContext,
  params: EventPayload<"CompensationReview_CampaignClosed">
) => {
  const campaign = await ctx.prisma.compensationReviewCampaign.findUniqueOrThrow({
    where: { id: params.campaignId },
  });

  const reviewersToNotify = await value(async () => {
    const reviewers = await ctx.prisma.compensationReviewReviewer.findMany({
      where: {
        campaignId: campaign.id,
      },
      select: {
        externalEmployee: {
          select: {
            userPermissions: {
              select: {
                user: {
                  select: selectUserForFormat,
                },
              },
            },
          },
        },
      },
    });

    return chain(reviewers)
      .map((reviewer) => reviewer.externalEmployee.userPermissions?.user)
      .compact()
      .value();
  });

  await track(ctx, "Compensation Review Campaign Closed", {
    notifyReviewers: campaign.closeNotificationEnabled,

    onBehalfOfUser: params.onBehalfOfUser,
    company: formatKnockTenant(params.onBehalfOfUser.company),
    campaign: formatCompensationReviewCampaign(campaign),
    reviewers: reviewersToNotify.map(formatKnockUser),
  });
};
